export enum PlayerActionType {
  SEEK = 'seek',
  PLAY = 'play',
  PAUSE = 'pause',
  PLAY_PREVIOUS = 'play_previous',
  PLAY_NEXT = 'play_next',
  LINK_TO_SPOTIFY = 'link_to_spotify',
}

export type PlayerAction =
| { type: PlayerActionType.SEEK; position: number }
| { type: PlayerActionType.PLAY }
| { type: PlayerActionType.PAUSE }
| { type: PlayerActionType.PLAY_PREVIOUS }
| { type: PlayerActionType.PLAY_NEXT }
| { type: PlayerActionType.LINK_TO_SPOTIFY; trackId: string };
